import type { Industry } from '../types/content';

export const industries: Industry[] = [
  {
    id: 'financial-services',
    name: 'Financial Services',
    summary: 'Banking, asset management, insurance, and fintech leaders navigating regulation and digital change.',
    roles: ['CEO', 'CFO', 'Chief Risk Officer', 'Head of Investments'],
  },
  {
    id: 'technology',
    name: 'Technology',
    summary: 'Software, platforms, and infrastructure businesses scaling through growth and transformation.',
    roles: ['CEO', 'CTO', 'Chief Product Officer', 'CRO'],
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Life Sciences',
    summary: 'Providers, pharmaceuticals, medtech, and health services organizations advancing patient outcomes.',
    roles: ['CEO', 'Chief Medical Officer', 'COO', 'Head of R&D'],
  },
  {
    id: 'industrial',
    name: 'Industrial & Manufacturing',
    summary: 'Manufacturers and engineering firms modernizing operations and supply chains.',
    roles: ['Managing Director', 'COO', 'Head of Operations', 'CFO'],
  },
  {
    id: 'energy',
    name: 'Energy & Infrastructure',
    summary: 'Utilities, renewables, and infrastructure leaders delivering the energy transition.',
    roles: ['CEO', 'Chief Commercial Officer', 'Head of Projects', 'CFO'],
  },
  {
    id: 'consumer',
    name: 'Consumer & Retail',
    summary: 'Brands and retailers reshaping how they reach and serve customers.',
    roles: ['CEO', 'Chief Marketing Officer', 'Chief Digital Officer', 'COO'],
  },
  {
    id: 'private-equity',
    name: 'Private Equity & Portfolio',
    summary: 'Portfolio leadership for investors seeking value creation across the hold period.',
    roles: ['Portfolio CEO', 'Portfolio CFO', 'Operating Partner', 'Chair'],
  },
  {
    id: 'public-nonprofit',
    name: 'Public Sector & Not-for-Profit',
    summary: 'Mission-driven organizations seeking leaders who combine purpose with operational excellence.',
    roles: ['Chief Executive', 'Trustee', 'Director of Finance', 'Executive Director'],
  },
];
